import { del, get, post, postFormData, put } from '@eika-infrastruktur/request';

import { HttpClient, RestResponse } from '../generated-types';
import { RequestType } from './request-type';
import WebRestApplicationClient from './web-rest-application-client';

const BASE_URL = '/kreditt-boliglaankalkulator-web/rest/resource';

export const paramsToString = (queryParams?: Record<string, string | string[]>): string => {
    if (queryParams === undefined || Object.keys(queryParams).length === 0) return '';
    const queryString = Object.keys(queryParams)
        .filter((key: string) => queryParams[key])
        .flatMap((key: string) => {
            const value = queryParams[key];
            if (value instanceof Array) {
                return value.map((element) => `${key}=${element}`);
            }
            return [`${key}=${value}`];
        })
        .join('&');
    return `?${encodeURI(queryString)}`;
};

export class WebHttpClient implements HttpClient<HeadersInit> {
    constructor(protected requestClient: RequestType) {
        this.requestClient = requestClient;
    }

    request<R>({
        url,
        copyFn,
        method,
        queryParams,
        data,
        options,
    }: {
        method: string;
        url: string;
        queryParams?: Record<string, string | string[]>;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        data?: any;
        copyFn?: (data: R) => R;
        options?: HeadersInit;
    }): RestResponse<R> {
        const resourceUrl = `${BASE_URL}/${url}${paramsToString(queryParams)}`;
        if (copyFn === undefined) return Promise.reject(Error('missing copyFn'));
        const clientOptions: RequestInit = {
            headers: options,
        };

        if (data instanceof FormData) {
            return this.requestClient.postFormData(resourceUrl, data, clientOptions).then((value) => copyFn(value));
        }

        switch (method) {
            case 'GET':
                return this.requestClient.get(resourceUrl, clientOptions).then((value) => copyFn(value));
            case 'POST':
                return this.requestClient.post(resourceUrl, data, clientOptions).then((value) => copyFn(value));
            case 'PUT':
                return this.requestClient.put(resourceUrl, data, clientOptions).then((value) => copyFn(value));
            case 'DELETE':
                return this.requestClient.del(resourceUrl, clientOptions).then((value) => copyFn(value));
            default:
                return Promise.reject(Error('missing method'));
        }
    }
}

export const restClient = new WebRestApplicationClient(new WebHttpClient({ get, post, put, del, postFormData }));
export default restClient;
